import Vue from 'vue'
import App from './App.vue'
import './plugins/element.js'
import { parseToken, loadEnvironment } from './constants'

Vue.config.productionTip = false

parseToken()

loadEnvironment().then((env) => {
  new Vue({
    render: h => h(App),
    data () {
      return {
        env,
      }
    }
  }).$mount('#app')
})
